export const setTopFilterReducer = (state, action) => {
    const { sectionId, widgetId, filterDirection, filterRowCountLimit, filterColumnId } = action.payload;
    const currentStatusWidgets = state.currentStatus.sections?.[sectionId]?.widgets;
    if (currentStatusWidgets && currentStatusWidgets[widgetId]) {
        currentStatusWidgets[widgetId].filterRowCountLimit = filterRowCountLimit;
        currentStatusWidgets[widgetId].filterDirection = filterDirection;
        currentStatusWidgets[widgetId].filterColumnId = filterColumnId;
    }
};
